/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "./Alert";
import L from "./Lang"
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { SidebarGlobal } from "./_SidebarGlobal";
import { Modal } from "react-bootstrap";
import { Pop } from "./PopModal";

class Providers extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {},
            loaded: false,
            loading: false,
            list: []
        };
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <Link to="/provider/new" className="btn btn-primary"><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline"><L>New Provider</L></span></Link>
        </div></>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load() {
        this.setState({ loading: true });
        qreq.post('/api/provider/list', this.state.query, j => {
            if (j.list) {
                this.setState({ list: j.list });
            }
            else if (j.errorCode !== 0) {
                this.setState({ errorMessage: j.errorMessage });
            }
            this.setState({ loaded: true, loading: false });
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
        });
    }

    render() {
        const header = (<h1><L>Providers</L></h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        return <div className="container-fluid">
            {header}
            <DataTable columns={[
                { icon: 'Pencil', link: '/provider/edit/:id', tooltip: 'Edit Provider' },
                {
                    icon: 'Trash', tooltip: 'Disable Provider', onClick: row => {
                        Pop.showConfirm(<div><L>Are you sure you want to disable this provider?</L></div>, 'Disable Provider', () => {
                            qreq.post('/api/provider/disable', { id: row.id }, j => {
                                if (j.errorCode === 0) {
                                    this.success('Provider disabled.');
                                    this.load();
                                }
                                else {
                                    this.alert(j.errorMessage);
                                }
                            }, this.unkownErrorCallback);
                        });
                    }
                },
                { name: 'id', title: 'ID', link: '/provider/edit/:id', tooltip: 'Edit Provider' },
                { name: 'name', title: 'Provider Name', link: '/provider/edit/:id', tooltip: 'Edit Provider' },
                { name: 'npi', title: 'NPI' },
                { name: 'createdDate', title: 'Created', format: 'datetime' }
            ]} data={this.state.list} loading={this.state.loading} />
        </div>;
    }
}

export default withParamsAndNavigate(Providers);